export default __webpack_public_path__ + "static/media/banner2.a1c8eb62.jpg";